import * as tslib_1 from "tslib";
import { FormGroup } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { FormComponent, } from '@components/ui-upsert-page/ui-form.component';
import { ITEMS_ACTIVATION_MAX, ITEMS_PER_JOB_ACTIVATION_MAX, MAX_JOBS_ACTIVATION_MAX, } from '@pages/triggers/upsert/trigger.upsert.page.models';
import { QueueDefinitionService, } from '@services';
import { switchMap } from 'rxjs/operators';
var QueueTriggerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(QueueTriggerComponent, _super);
    function QueueTriggerComponent(_appState, _queueService) {
        var _this = _super.call(this) || this;
        _this._appState = _appState;
        _this._queueService = _queueService;
        _this.queueSearchFactory = function (searchTerm, fetchSize, skipCount) {
            return _this._appState.user.folder.value$
                .pipe(switchMap(function (_) {
                return _this._queueService.queueTriggerSuggest(_this.triggerId, searchTerm, fetchSize, skipCount);
            }));
        };
        return _this;
    }
    Object.defineProperty(QueueTriggerComponent.prototype, "itemsActivationThresholdMax", {
        get: function () { return ITEMS_ACTIVATION_MAX; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueueTriggerComponent.prototype, "itemsPerJobActivationTargetMax", {
        get: function () { return ITEMS_PER_JOB_ACTIVATION_MAX; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueueTriggerComponent.prototype, "maxJobsForActivationMax", {
        get: function () { return MAX_JOBS_ACTIVATION_MAX; },
        enumerable: true,
        configurable: true
    });
    QueueTriggerComponent.prototype.changedMaxJobsForActivation = function (max) {
        if (Number(max) !== 1) {
            return;
        }
        this.getField('itemsPerJobActivationTarget').setValue(1);
    };
    return QueueTriggerComponent;
}(FormComponent));
export { QueueTriggerComponent };
